import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetStorageApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useDeleteStorageItem = (options?: UseMutationOptions<void, unknown, string>) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string>(
    'delete-storage-item',
    async (itemId: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await assetStorageApi.assetStorageControllerRemove(assetId, itemId);
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        trackEvent('Storage Item', 'delete');
        queryClient.invalidateQueries({ queryKey: ['fetch-documents', assetId] });
      },
    }
  );
};
